<template>
  <nav class="language-switcher" :class="{ mobile }">
    <template v-for="(lang, index) in languages" :key="lang.code">
      <a
        :href="lang.url"
        :class="['lang-link', { active: currentLanguage === lang.code }]"
      >
        {{ lang.code.toUpperCase() }}
      </a>
      <span v-if="mobile && index < languages.length - 1" class="separator">/</span>
    </template>
  </nav>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  mobile: {
    type: Boolean,
    default: false
  }
});

// Get current language from document
const currentLanguage = ref(document.documentElement.lang !='<!--php <?php echo $lang; ?> -->' ? document.documentElement.lang : 'fi');

// Define available languages
const languages = [
  { code: 'fi', url: 'https://ennakointistudio.fi/fi' },
  { code: 'en', url: 'https://foresightstudio.fi/en' }
];
</script>

<style scoped>
nav.language-switcher {
  display: flex;
  gap: 1rem;
  padding: 2rem;
  align-items: center;
}

.lang-link {
  color: var(--mahogany);
  text-decoration: none;
  transition: color 0.2s ease-in-out;
  font-size: 1.25cqw;
}

.lang-link:hover {
  color: var(--dark);
}

/* Mobile styles */
nav.language-switcher.mobile {
  padding: 0;
}

.lang-link.active {
  border: 2px solid var(--mahogany-transparent);
  border-radius: 50%;
  font-size: 0.66em;
  position: relative;
  bottom: -0.05rem;
  content: counter(link-number);
  padding-top: 0.43em;
  padding-bottom: 0.46em;
  padding-left: 0.09em;
  padding-right: 0.11em;
  text-align: center;
  width: 3.75ch !important;
  display: inline-block;
  border: 2px solid var(--mahogany-transparent);
  border-radius: 50%;
}

nav.language-switcher.mobile .lang-link {
  font-family: var(--font-serif);
  font-size: var(--text-2xl);
  line-height: var(--leading-tight);
  font-weight: var(--font-regular);
}

nav.language-switcher.mobile .lang-link.active {
  font-weight: var(--font-semibold);
}

nav.language-switcher.mobile .separator {
  font-family: var(--font-serif);
  color: var(--mahogany);
  font-size: var(--text-2xl);
  line-height: var(--leading-tight);
  font-weight: var(--font-regular);
}
</style>
